import { useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getAllStainGrams,CreateStaingGrams,UpdateStaingGrams,DeleteStaingGrams} from '../../services/micro/micro'

export const useStainGrams = () => {

    const [createSweet] = useSweetAlert();
    const [listStainGrams, setListStainGrams] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchListBacteriumCount, setSearchListBacteriumCount] = useState([])

    // ? MODAL CRUD
    const [modal, setModal] = useState(false)
    const [tittle, setTittle] = useState("")
    const [method, setMethod] = useState("")
    const [id_resistance, setId_resistance] = useState(0);
    const [titleDelete, setTitleDelete] = useState("")
    // ? Alert Modal
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    // ? search 
    const [searchStainGrams, setSearchStainGrams] = useState("");
    const [loadingExport, setLoadingExport] = useState(false);
    
    // * FORM 
    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name:"",
    });

    const {
        name,
    } = formValues;
   
    useEffect(() => {
        getBacteriumCount()
    }, []);
    
    const getBacteriumCount = async (_type) =>
        {
            const resistance = await getAllStainGrams();    

            if (resistance?.length > 0)
            {
                let startItems = 0;
                let endItems = numberItems;
                let aux = numberItems * currentPage;
                let _new_list = [];

                endItems = aux;
                startItems = endItems - numberItems;

                resistance.forEach((_find,_key) => {
                    let posicion = _key + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }
                    _new_list.push({
                        id_mic_stain_gram: _find?.id_mic_stain_gram ?? null,
                        name: _find?.name ?? null,
                        visibleTable: visibleTable,
                    })
                });
                setListStainGrams(_new_list);      
                setSearchListBacteriumCount(_new_list)              
            }
    }


    const openDialogG = (title, mode) => {
        setTittle(title);
        setMethod(mode);
        setModal(true);
    };
    const closeDialogG = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);
        setShowDeleteAlert(false);
    };


    // * CRUD TABLE
    const handleCreate = () => 
    {        
        handleUpdateValues({
            name:"",
        })
        setMethod("create")
        openDialogG("Crear tinción de gram", "create");
    }

    const saveCreate =async (e) => 
    {
        e.preventDefault();
        
        setLoading(true);
        const response = await CreateStaingGrams({
            name: formValues.name,  
        });

        if (response.code === 200){
            setLoading(false);
            getBacteriumCount()
            createSweet("success", "success", "Se a creado correctamente");
            closeDialogG();
            handleUpdateValues({
                name:"",
            })
        } 
    }

    const handleUpdate = (id_mic_stain_gram) => 
    {
        let list = listStainGrams.find(c => c.id_mic_stain_gram === parseInt(id_mic_stain_gram));

        if (list !== "" || list !== null) {

            handleUpdateValues({
                name: list?.name,
            });
            setTittle("Actualizar")
            setId_resistance(id_mic_stain_gram)
            setMethod("update")
            openDialogG("Editar tinción de gram", "update");
        }
    }

    const saveUpdateStain = async (e) => 
    {
        e.preventDefault();
        setLoading(true);

        const response = await UpdateStaingGrams({
            id_mic_stain_gram: id_resistance,
            name: formValues.name,   
        });

        if (response.code === 200){
                setLoading(false);
                createSweet("success", "success", "Se a actualizado correctamente");
                getBacteriumCount()
                closeDialogG();
            handleUpdateValues({
                name:"",
            })
            setId_resistance(0);
        } 
    }

    const handleDelete = (id_mic_stain_gram,_name) => 
    {
        let list = listStainGrams.find(c => c.id_mic_stain_gram === parseInt(id_mic_stain_gram));

        if (list !== "" || list !== null) {

            handleUpdateValues({
                name: list.name,
            });
            setTitleDelete(list.name)
            setId_resistance(id_mic_stain_gram)
            setMethod("delete")
            openDeleteAlert();
        }
    }

    const saveDeleteStain= async (e) => 
    {
        e.preventDefault();
    
        setLoading(true);
    
        const response = await DeleteStaingGrams({
            id_mic_stain_gram : id_resistance
        });
    
        if (response.code === 200){
            setLoading(false);
            createSweet("success", "success", "Se a eliminado correctamente");
            closeDeleteAlert();        
            getBacteriumCount()
            handleUpdateValues({
                name:"",
            })
            setId_resistance(0);
        } 
    }

    // ? PAGINATION 
    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(listStainGrams.length, numberItems);

    useEffect(() => {

        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;

        let listcompanies = [];
        listStainGrams.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listcompanies.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setListStainGrams(listcompanies);

    }, [totalPageCount, currentPage]);
   
    // ? SEARCH TYPE DISCOUNT
    const handleSearchStainGrams = (e) => {
        setSearchStainGrams(e);

        let busqueda = e.toUpperCase();
        let newMethod = [];

        searchListBacteriumCount.forEach(element => {

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setListStainGrams(newMethod);
    }

    const handleClearStainGrams = () => {
        setSearchStainGrams("");                         
        localStorage.removeItem("globalFilter");    
        setListStainGrams(searchListBacteriumCount);                    
    };

      const handleExportExcelStainGrams = async () => {
        setLoadingExport(true);
        try {
            const XLSX = await import("xlsx");

          const _report = listStainGrams.map((item, index) => ({
                "#": index + 1,
                Gram: item.name ?? "---",
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Tinción de Gram");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catalogo_tincion_Gram.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };



    return {
         // * LIST
        listStainGrams,

        //* CRUD TABLE
        handleCreate,handleUpdate,handleDelete,method,modal,tittle,
        name,handleInputChange,titleDelete,
        saveCreate,saveUpdateStain,saveDeleteStain,loading,
        handleExportExcelStainGrams,

        //* SEARCH
        handleSearchStainGrams, handleClearStainGrams, searchStainGrams, loadingExport, 

        //*DIALOG
        closeDeleteAlert, closeDialogG,
        showDeleteAlert, modalAlert, 
    }
}
